"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconMessage = void 0;
var React = __importStar(require("react"));
var IconMessage = function (props) { return (React.createElement("svg", __assign({ width: "34px", height: "34px", viewBox: "0 0 34 34" }, props),
    React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
        React.createElement("g", null,
            React.createElement("rect", { id: "Rectangle", fill: "#52C951", x: 0, y: 0, width: 34, height: 34, rx: 4 }),
            React.createElement("path", { d: "M17.1671688,26.6417863 C15.4099101,26.6417863 13.7193152,26.3297133 12.1407155,25.7144204 C12.0020547,25.660195 11.8473946,25.6469153 11.6967343,25.6790079 C11.5367411,25.7122071 11.2140881,25.7830322 10.7874396,25.8770968 C9.37683277,26.1880631 6.75027757,26.7679435 5.44766619,26.9726722 C5.09301457,27.0291109 5.02368418,26.9815253 5.00635158,26.9759921 C5.00635158,26.9759921 4.98768571,26.9328331 5.01435124,26.8111025 C5.25567433,25.6557684 6.2556319,22.6789018 6.63161594,21.6320186 C6.68094718,21.4970083 6.66494786,21.3509316 6.58895109,21.2247744 C5.75698639,19.8514319 5.33567094,18.3696384 5.33567094,16.8214465 C5.33567094,11.4055412 10.6434457,7 17.1671688,7 C23.6922253,7 29,11.4055412 29,16.8214465 C29,22.2362451 23.6922253,26.6417863 17.1671688,26.6417863", id: "ic_who_you_are", fill: "#FFFFFF" }))))); };
exports.IconMessage = IconMessage;
exports.IconMessage.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconMessage;
